import React, { useContext } from 'react';
import { getPrivacyPolicyData } from '@/constants/privacyPolicyData';
import { DetailsContext } from '@/context/DetailContext';

export const PrivacyPolicy = () => {
  const { details } = useContext(DetailsContext);

  // Generate the privacy policy data dynamically from context
  const privacyPolicyData = getPrivacyPolicyData({
    email: details?.email || '',
    phone: details?.phone || '',
    address: details?.address || '',
  });

  const getIcon = (icon) => {
    // Import your icons at the top and map them here if needed
    // const icons = { Lock, FileText, UserCheck, PhoneCall, ShieldCheck, Cookie };
    // const Icon = icons[icon];
    // return Icon ? <Icon className="mb-[1rem] h-[3rem] w-[3rem] text-[#e24e1f]" /> : null;
    return null;
  };

  return (
    <div className="mt-[12rem] flex w-full justify-center px-[2rem] font-inter lg:mt-[15rem]">
      {' '}
      <div className="w-full max-w-[100rem]">
        {/* Header */}{' '}
        <div className="mb-[4rem] text-center">
          {' '}
          <h1 className="mb-[1rem] text-[3.6rem] font-[700] text-[white]">
            {privacyPolicyData.title}{' '}
          </h1>{' '}
          <p className="mx-auto max-w-[80rem] text-[1.6rem] text-[#828FA0]">
            {privacyPolicyData.subtitle}{' '}
          </p>{' '}
        </div>
        ```
        {/* Sections */}
        {privacyPolicyData.sections.map((section) => (
          <div key={section.id} className="mb-[2rem] rounded-xl bg-[#011936] p-[3rem]">
            {getIcon(section.icon)}
            <h2 className="mb-[1rem] text-[1.8rem] font-[700] text-white md:text-[2rem] lg:text-[2rem]">
              {section.title}
            </h2>

            {section.content.length > 1 ? (
              <ul className="list-disc space-y-[0.5rem] pl-[3rem] text-[1.6rem] text-[#828FA0]">
                {section.content.map((line, index) => (
                  <li key={index}>{line}</li>
                ))}
              </ul>
            ) : (
              <p className="text-[1.6rem] text-[#828FA0]">{section.content[0]}</p>
            )}
          </div>
        ))}
        {/* Footer */}
      </div>
    </div>
  );
};
